<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="60%">
            <v-card>
                <v-card-title>
                    <span class="text-h5">Incasso</span>
                </v-card-title>
                <v-card-text>
                    <v-form ref="form" v-model="valid" lazy-validation>
                        <v-container>
                            <v-row>
                                <v-col cols="12" sm="6" md="4">
                                    <v-select :items="arrShop" v-model="incasso.shop_id" label="Negozi"
                                        item-text="description" item-value="id" required :rules="formRules.shopId">
                                    </v-select>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field type="text" label="Operatore" v-model="incasso.operatore" required
                                        :rules="formRules.operatore"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                                        transition="scale-transition" offset-y min-width="auto">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="incasso.data_incasso" label="Data incasso"
                                                prepend-icon="mdi-calendar" readonly v-bind="attrs"
                                                :rules="formRules.data_incasso" required v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="incasso.data_incasso"
                                            @input="menu2 = false"></v-date-picker>
                                    </v-menu>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="6" md="2">
                                    <v-text-field type="number" label="Incasso" prefix="€" v-model="incasso.incasso"
                                        required :rules="formRules.incasso"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                    <v-text-field type="number" label="POS" prefix="€"
                                        v-model="incasso.pos"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                    <v-text-field type="number" label="Satispay" prefix="€"
                                        v-model="incasso.satispay"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                    <v-text-field type="number" label="Spese" prefix="€"
                                        v-model="incasso.spese"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                    <v-text-field type="number" label="Versamento" prefix="€"
                                        v-model="incasso.versamento"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                    <v-text-field type="number" label="IVA 22%" prefix="€"
                                        v-model="incasso.iva22"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                    <v-text-field type="number" label="IVA 10%" prefix="€"
                                        v-model="incasso.iva10"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                    <v-text-field type="number" label="IVA 5%" prefix="€"
                                        v-model="incasso.iva5"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                    <v-text-field type="number" label="IVA 4%" prefix="€"
                                        v-model="incasso.iva4"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                    <v-text-field type="number" label="Numero Scontrini"
                                        v-model="incasso.num_scontrini"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                    <v-text-field type="number" label="Conta Persone"
                                        v-model="incasso.conta_persone"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-select
                                        :items="['Sereno', 'Nuvoloso', 'Pioggia', 'Temporale', 'Neve', 'Freddo Intenso', 'Caldo Intenso']"
                                        v-model="incasso.meteo" label="Meteo"></v-select>
                                </v-col>
                                <v-col cols="12">
                                    <v-textarea label="Note" rows="3" v-model="incasso.note"></v-textarea>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialog = false">
                        Close
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="saved()">
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
export default {
    props: {
        incasso: {
            type: Object,
            default: {}
        },
        arrShop: {
            type: Array,
            defaul: []
        },
        open: {
            type: Boolean,
            default: false
        }
    },

    watch: {
        open(newVal) {
            if (newVal) this.dialog = true;
            else this.dialog = false;
        },
        dialog(newVal) {
            if (!newVal) this.onClosed();
        }
    },

    data: () => ({
        dialog: false,
        menu2: false,
        valid: true,
        formRules: {
            shopId: [
                v => !!v || 'Negozio obbligatorio',
            ],
            operatore: [
                v => !!v || 'Operatore obbligatorio',
            ],
            incasso: [
                v => !!v || 'Incasso obbligatorio',
            ],
            data_incasso: [
                v => !!v || 'Data obbligatoria',
            ],
        }
    }),

    methods: {
        onClosed() {
            this.$emit('onClose');
        },
        saved() {
            if (this.$refs.form.validate()) {
                this.$emit('onSave', _.clone(this.incasso));
            }
        }
    }
}
</script>
